import { useState, useEffect } from "react"

interface UseTimerProps {
    initialSeconds: number
    autoStart?: boolean
    isCountdown?: boolean
}

export const useTimer = ({
    initialSeconds,
    autoStart = false,
    isCountdown = true,
}: UseTimerProps) => {
    const [seconds, setSeconds] = useState(initialSeconds)
    const [isRunning, setIsRunning] = useState(autoStart)

    const start = () => {
        setIsRunning(true)
    }

    const pause = () => {
        setIsRunning(false)
    }

    const reset = () => {
        if (!autoStart) {
            pause()
        }

        if (isCountdown) {
            setSeconds(initialSeconds)
        } else {
            setSeconds(0)
        }
    }

    useEffect(() => {
        if (isCountdown && seconds === 0) {
            setIsRunning(false)
        }
    }, [seconds])

    useEffect(() => {
        if (isRunning) {
            const timer = setInterval(() => {
                setSeconds((prev) => {
                    if (isCountdown) {
                        if (prev > 0) {
                            return prev - 1
                        } else {
                            clearInterval(timer)
                            return 0
                        }
                    } else {
                        return prev + 1
                    }
                })
            }, 1000)

            return () => {
                clearInterval(timer)
            }
        }
    }, [isRunning, isCountdown])


    return {
        seconds,
        isRunning,
        start,
        pause,
        reset,
    }
}